import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppTableComponent, Auth, Form, MessagesComponent, OpnOfferEvaluationMethodModel, OpnOfferEvaluationMethodSaveModel, OpnOfferEvaluationMethodsService, RequestsService, RequestStatusUniqueIdentifier, SearchModel, SearchResultModel, TranslationManager, ViewState } from 'src/common';
import { OpnOfferEvaluationMethodElementsComponent } from 'src/views';

@Component({
  selector: 'opn-offer-evaluation-methods',
  templateUrl: './opn-offer-evaluation-methods.component.html'
})
export class OpnOfferEvaluationMethodsComponent implements OnInit {
  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("elements") elements: OpnOfferEvaluationMethodElementsComponent;
  @Output() checkTabs:EventEmitter<boolean>= new EventEmitter();

  @Input() state: ViewState;
  @Input() requestId: number;

  auth = Auth;
  viewState = ViewState;
  form: Form = new Form();
  translationManager = TranslationManager;
  requestStatusUniqueIdentifier = RequestStatusUniqueIdentifier;

  items: OpnOfferEvaluationMethodModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  requestStatus: string;
  pointsSum: number = 0;

  constructor(private requestService: RequestsService,
    private opnOfferEvaluationMethodsService: OpnOfferEvaluationMethodsService,
    private router: Router) { }

  ngOnInit(): void {

    this.getAll();

    // this.requestService.getRequestStatusUnique(this.requestId).then(result => {
    //   this.requestStatus = result.requestStatus;
    // });
  }

  getAll() {
    this.pointsSum = 0;

    this.requestService.opnOfferEvaluationMethodsGetAll(this.requestId).then((result: OpnOfferEvaluationMethodModel[]) => {
      this.items = result;
      this.pointsSum = result.reduce((sum, item) => sum + item.points, 0);
    });
  }

  submit() {
    let isValidForm = this.form.isValid();
    let isValidElements = this.elements.isValid();
    let elements: OpnOfferEvaluationMethodModel[] = isValidElements ? this.elements.getElements() : [];

    if (isValidForm && elements.length > 0) {

      let pointsSumWithElements = elements.reduce((sum, item) => sum + item.points, 0);

      if (this.pointsSum + pointsSumWithElements <= 100) {
        let model: OpnOfferEvaluationMethodSaveModel = new OpnOfferEvaluationMethodSaveModel();

        model.requestId = this.requestId;
        model.elements = elements;

        this.opnOfferEvaluationMethodsService.save(model).then(() => {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
          this.getAll();
          this.elements.deleteAll();
          this.checkTabs.emit(true);
        });
      }
      else {
        MessagesComponent.instance.showError([this.translationManager.getTranslation('Збир бодова не може бити већи од 100')]);
      }
    }
  }



  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  closeDeleteModal(){
    this.idForDelete = 0;
    this.showDeleteModal = false;
  }

  delete() {
    if (this.idForDelete > 0) {
      this.opnOfferEvaluationMethodsService.delete(this.idForDelete).then(() => {
        this.closeDeleteModal();
        this.getAll();
        this.checkTabs.emit(true);
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  navigateToList() {
    this.router.navigate(['/requests']);
  }
}
